(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[28505],{

/***/ 72356:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/alquiler-temporal/viviendas",
      function () {
        return __webpack_require__(55753);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 55753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11720);
/* harmony import */ var _templates__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37682);
/* harmony import */ var _templates__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37140);



const FlatCategory = (param)=>/*#__PURE__*/ {
    let { serverState , page: { minBookingDays , attributes: { Content: dynamicContent  }  }  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_templates__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                defaultArea: "todas las zonas",
                typeText: "de alquiler temporal",
                serverState: serverState,
                type: "MED_EST",
                minBookingDays: minBookingDays
            }),
            dynamicContent.map((param, index)=>/*#__PURE__*/ {
                let { __typename , ...props } = param;
                return (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(_templates__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    type: __typename,
                    ...props,
                    key: "".concat(__typename, "-").concat(index)
                });
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (FlatCategory);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [92456,21894,18866,61122,37140,37682,92888,40179], function() { return __webpack_exec__(72356); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);